class GraphQLClass {
    constructor() {
        this.endpoint = '/local/graphql/'
    }

    getSelectedFields(fields) {
        let result = ''

        const keys = Object.keys(fields)

        if (keys.length > 0) {
            result += '{\r\n'

            keys.forEach((key) => {
                if (fields[key]) {
                    result += key + ' ' + this.getSelectedFields(fields[key])
                } else {
                    result += key + '\r\n'
                }
            })

            result += '}\r\n'
        } else {
            return result
        }

        return result
    }

    query(queryName, variables={}, fields={}, cb) {
        const params = Object.keys(variables).reduce((r, key) => {
            const str = key.split(':').reduce((res, s) => {
                res.push(s.trim())

                return res
            }, [])

            r.push({
                _key : key,
                key : str[0],
                type : str[1],
                value : variables[key]
            })

            return r
        }, []).reduce((r, el) => {
            r.queryParams.push(`$${ el._key }`)
            r.queryVariables.push(`${ el.key } : $${ el.key }`)
            r.variables[el.key] = el.value

            return r
        }, {
            queryParams : [],
            queryVariables : [],
            variables : {}
        }),
        query = params.queryVariables.length > 0 ? `query Query_${ queryName }(${ params.queryParams.join(', ') }) {
            ${ queryName }(
                ${ params.queryVariables.join(',\r\n') }
            )
            ${ (Object.keys(fields).length > 0) ? this.getSelectedFields(fields) : '' }
        }` : `query Query_${ queryName } {
            ${ queryName }
            ${ this.getSelectedFields(fields) }
        }`

        fetch(this.endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify({
                query,
                variables: params.variables,
            })
        })
        .then(r => r.json())
        .then((data) => {
            if (cb) {
                cb(data.errors || null, data.errors ? null : data.data[queryName])
            }
        })
        .catch((err) => {
            cb(err, null)
        })
    }
}

const GraphQL = new GraphQLClass()

export default GraphQL